export const eventOptions = [
  {
    value: 'contact_score_crossed',
    label: 'Pontuação do contato mudou de faixa',
  },
];

export const labelOptions = [
  { value: 'frio', label: 'Frio' },
  { value: 'morno', label: 'Morno' },
  { value: 'quente', label: 'Quente' },
  { value: 'muito_quente', label: 'Muito quente' },
];

export const directionOptions = [
  { value: 'upgrade', label: 'Subiu de faixa' },
  { value: 'downgrade', label: 'Desceu de faixa' },
  { value: 'none', label: 'Sem alteração de direção' },
];

export const conditionAttributeSchema = {
  from_label: {
    label: 'Faixa de origem',
    inputType: 'select_label',
    multiple: true,
  },
  to_label: {
    label: 'Faixa de destino',
    inputType: 'select_label',
    multiple: true,
  },
  direction: {
    label: 'Direção',
    inputType: 'select_direction',
    multiple: true,
  },
};

export const conditionAttributeOptions = Object.entries(
  conditionAttributeSchema
).map(([value, config]) => ({
  value,
  label: config.label,
}));

export const actionSchema = {
  add_contact_label: {
    label: 'Adicionar etiqueta ao contato',
  },
  send_webhook_event: {
    label: 'Enviar webhook',
  },
  create_deal: {
    label: 'Criar negócio',
  },
  create_activity: {
    label: 'Criar atividade',
  },
};

export const actionOptions = Object.entries(actionSchema).map(
  ([value, config]) => ({
    value,
    label: config.label,
  })
);

export const getOptionLabel = (options, value, fallback = '-') => {
  const found = options.find(option => option.value === value);
  return found?.label || value || fallback;
};

export const getOptionLabels = (options, values) => {
  if (!Array.isArray(values) || !values.length) return '-';
  return values.map(value => getOptionLabel(options, value)).join(', ');
};
